import sendReportRequest from './sendReportRequest';

const fetchReportTopCustomers = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/topCustomers',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportTopCustomers;
